import React from 'react';

import BaseIcon from './base';
import path from '../../../assets/Dashboard/scooter.svg';

export default function ScooterSvgIcon({ classes }) {
  return (
    <BaseIcon classes={classes} altText="scooter" path={path} />
  );
}
